import { motion } from 'framer-motion';
import React from 'react';
import SectionHeader from '../components/CommonComps/Titles/SectionHeader';
import { sectionAnimVariants } from '../constants/animationVariants';

const DashboardSectionLayout = ({
  children,
  sectionTitle,
  additionalClassNames,
}: {
  children: React.ReactNode;
  sectionTitle: string;
  additionalClassNames?: string;
}) => {
  // rendering dashboard section layout component here
  return (
    <motion.section
      variants={sectionAnimVariants}
      initial='initial'
      animate='animate'
      className={`p-3 md:p-5 bg-base-white rounded-lg shadow-academia-sm ${
        additionalClassNames ? additionalClassNames : ''
      }`}
    >
      <SectionHeader headerText={sectionTitle} />

      {children}
    </motion.section>
  );
};

export default DashboardSectionLayout;
